import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=bfed2f6c"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"
import style0 from "./EmptyPage.vue?vue&type=style&index=0&id=bfed2f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports